<template>
  <div>
    <div id="btn_area">
      <h4>合計金額 : {{ price !== null ? price : 0 }}</h4>
      <!-- <span class="text_button" @click="refresh"><i class='bx bx-revision'></i></span> -->
      <!-- TODO 現状未使用
      <h4>個別カラースタイル設定</h4>
      <input placeholder="spaceId" v-model="colorSpaceId">
      <input placeholder="cabinetColor" v-model="cabinetId">
      <input placeholder="doorColor" v-model="doorId">
      <input placeholder="counterColor" v-model="counterId">
      <input type="button" value="設定" @click="editOwnColorStyle">
      -->
    </div>
    <div id="data_area" v-if="fileData && fileData.topSpaceModel">
      <ul>
        <dd-space-tree-item
          :ref="'spaceTreeItemRef' + fileData.topSpaceModel.id"
          :fileData="fileData"
          :space="fileData.topSpaceModel"
          :treeStatusMap="treeStatusMap"
          :focusedMenuSpace="focusedMenuSpace"
          :editSpaceIds="editSpaceIds"
          :isFocusedParts="isFocusedParts"
          :isFocusedPartsParent="isFocusedPartsParent"
          :isFocusedOneRelatedToShelf="isFocusedOneRelatedToShelf"
          @setFocusedSpace="setFocusedSpace"
          @setSelectedSpace="setSelectedSpace"
        />
      </ul>
    </div>
    <div v-else>データがありません。</div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, STORAGE_KEY} from '../../../constants/App'
import {LICENSE_TYPE} from '../../../constants/Type'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import SpaceTreeItem from './SpaceTreeItem'

export default {
  name: 'SpaceTree',
  components: {
    'dd-space-tree-item': SpaceTreeItem
  },
  props: {
    fileDataProp: Object,
    focusedMenuSpace: Object,
    isFocusedParts: Boolean,
    isFocusedPartsParent: Boolean,
    isFocusedOneRelatedToShelf: Boolean,
    price: Number
  },
  data: function () {
    return {
      fileData: {},
      treeStatusMap: {},
      editSpaceIds: []
      // TODO 個別カラースタイル設定を使用する際、定義を追加する,
      // colorSpaceId: '',
      // cabinetId: '',
      // doorId: '',
      // counterId: ''
    }
  },
  watch: {
    fileDataProp: function () {
      this.fileData = Object.assign({}, this.fileDataProp)
      this.createTreeStatusMap()
    }
  },
  computed: {
  },
  methods: {
    /** 編集中空間データ取得 */
    // refresh: function () {
    //   axios.get(API_URL.PLANNING + '/edit')
    //     .then(response => {
    //       if (!response || !response.data || !response.data.data) {
    //         this.fileData = {}
    //         this.treeStatusMap = {}
    //         AppUtil.removeLocalStorage(STORAGE_KEY.SPACE_TREE)
    //         return
    //       }
    //       this.fileData = response.data.data
    //       this.createTreeStatusMap()
    //     }).catch(error => {
    //       Api.handleError(error)
    //     })
    //   this.$emit('getPrice')
    // },
    /** TreeStatusMap(各空間の開閉、詳細表示/非表示状態を保持するマップ)を作成 */
    createTreeStatusMap: function () {
      this.treeStatusMap = {}
      if (this.fileData && Object.keys(this.fileData).length && this.fileData.topSpaceModel && Object.keys(this.fileData.topSpaceModel).length) {
        let treeStatusHistory = AppUtil.getLocalStorage(STORAGE_KEY.SPACE_TREE)
        this.createTreeStatus(this.fileData.topSpaceModel, treeStatusHistory)
      }
      AppUtil.setLocalStorage(STORAGE_KEY.SPACE_TREE, this.treeStatusMap)
    },
    createTreeStatus: function (space, treeStatusHistory) {
      this.treeStatusMap[space.id] = treeStatusHistory.hasOwnProperty(space.id) && !this.dispTrialUserTools()
        ? treeStatusHistory[space.id] // ローカルストレージにあり、かつお試しユーザーでなければ優先
        : { open: false, detail: false } // なければ、またはお試しユーザーならクローズ状態
      space.childrenSpaceModel.forEach(child => this.createTreeStatus(child, treeStatusHistory))
    },
    openBySpaceId: function (spaceIds, editIds) {
      this.editSpaceIds = editIds
      if (spaceIds.length > 0) {
        let ref = 'spaceTreeItemRef' + this.fileData.topSpaceModel.id
        this.$refs[ref].toggleOpenByEdit(spaceIds)
      }
    },
    openDefault: function () {
      let ref = 'spaceTreeItemRef' + this.fileData.topSpaceModel.id
      this.$refs[ref].toggleOpenDefault()
    },
    /** フォーカス空間emit用処理 */
    setFocusedSpace: function (spaceId) {
      this.$emit('setFocusedSpace', spaceId)
    },
    /** 選択空間emit */
    setSelectedSpace: function (spaceId) {
      this.$emit('setSelectedSpace', spaceId)
    },
    /** 個別カラースタイル設定 TODO 現状未使用 */
    editOwnColorStyle: function () {
      let payload = {
        /** TODO 本関数を採用する際は、カラーをdataから取得する
        spaceId: this.colorSpaceId,
        colorStyleDefault: this.cabinetId,
        colorStyleGroup1: this.doorId,
        colorStyleGroup2: this.counterId,
        colorStyleGroup3: null,
        colorStyleGroup4: null,
        colorStyleGroup5: null,
        colorStyleGroup6: null,
        colorStyleGroup7: null,
        colorStyleGroup8: null,
        colorStyleGroup9: null,
        colorStyleGroup10: null,
        colorStyleGroup1Str: null,
        colorStyleGroup2Str: null,
        colorStyleGroup3Str: null,
        colorStyleGroup4Str: null,
        colorStyleGroup5Str: null,
        colorStyleGroup6Str: null,
        colorStyleGroup7Str: null,
        colorStyleGroup8Str: null,
        colorStyleGroup9Str: null,
        colorStyleGroup10Str: null
        */
      }
      axios.post(API_URL.PLANNING + '/edit-own-color-style', payload)
        .then(response => {
          if (!response || !response.data || !response.data.data) {
            this.fileData = {}
            this.treeStatusMap = {}
            AppUtil.removeLocalStorage(STORAGE_KEY.SPACE_TREE)
            return
          }
          this.fileData = response.data.data
          this.createTreeStatusMap()
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** お試しユーザー用ツール表示 */
    dispTrialUserTools: function () {
      let user = AppUtil.getUserInfo()
      return user && LICENSE_TYPE.TRIAL === user.licenseType
    }
  }
}
</script>

<style src="../../../css/planning/side_tab_nav.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
// #btn_area {
//   position: relative;
// }
// .text_button {
//   position: absolute;
//   right: 0;
//   top: 0;
//   &:hover {
//     color: #ff4500;
//     cursor: pointer;
//   }
// }
// i {
//   font-size: 1.4em;
// }
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/tab/SpaceTree.vue